import { useQuery } from '@tanstack/react-query';
import { graphql } from '../gql/gql';
import { useAuth0 } from '../auth/AuthProvider';
import { graphqlRequest, shouldRetryQuery } from '../utils/graphqlClient';

const isAdminQuery = graphql(/* GraphQL */ `
  query isAdmin {
    isAdmin
  }
`);

const useIsAdmin = () => {
  const { getAccessTokenSilently, isAuthenticated } = useAuth0();

  const { data, isLoading } = useQuery({
    queryKey: ['isAdmin'],
    queryFn: async () => {
      const result = await graphqlRequest<{ isAdmin: boolean }>(
        isAdminQuery,
        undefined,
        getAccessTokenSilently,
      );
      return result.isAdmin;
    },
    enabled: isAuthenticated,
    staleTime: 300000, // 5 minutes
    retry: shouldRetryQuery,
  });

  return {
    isAdmin: data ?? false,
    isLoading,
  };
};

export default useIsAdmin;
